import * as types from "../constants";

export function UpdateLanguageOptions(payload: types.ILanguageData): types.IUpdateLanguageOptions {
    return {
        type: types.UPDATE_LANGAUGE_OPTIONS,
        payload
    };
}
